<div class="grid-cell-buttons display--flex-column">
    @if (isButtonVisible('up')) {
        <skl-icon name="angle-up" class="text--clickable" (click)="onMove.emit('up')"></skl-icon>
    } @else if (isButtonVisible('down')) {
        <skl-icon name="angle-down" class="text--clickable" (click)="onMove.emit('down')"></skl-icon>
    }
</div>
